<template>
  <div class="procurement">
    <v-tabs
      class="tabs"
      v-model="tab"
      background-color="transparent"
      hide-slider
      next-icon="mdi-arrow-right-bold-box-outline"
      prev-icon="mdi-arrow-left-bold-box-outline"
      show-arrows
      fixed-tabs
    >
      <v-tab
        class="tabs-item py-2"
        active-class="active"
        v-for="item in list"
        :key="item.id"
        @click="tabsChange(item)"
      >
        <span>{{item.title}}</span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="tabs-items">
      <TabItem  v-for="item in list" :item="item" :key="item.id" :head-left-title="headLeftTitle" :head-center-title="headCenterTitle" :head-right-title="headRightTitle" :pagination="pagination"></TabItem>
    </v-tabs-items>
  </div>
</template>

<script>
import TabItem from '@/components/Logistics/TabItem'
export default {
  name: 'Tabs',
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: true
    },
    headLeftTitle: {
      type: String
    },
    title: {
      type: String
    },
    headCenterTitle: {
      type: String
    }
    // ,headRightTitle: {
    //   type: String
    // }
  },
  components: {
    TabItem
  },
  data: () => ({
    tab: 0,
    headRightTitle: ''
  }),
  methods: {
    tabsChange (item) {
      if (this.title === 'engineering') {
        if (item.title === '企业公告') {
          this.headRightTitle = '发布时间'
          // this.$emit('headRightTitle', '发布时间')
        } else {
          this.headRightTitle = '截止时间'
          // this.$emit('headRightTitle', '截止时间')
        }
        this.$store.commit('setTab', [0, item.id])
      }
      if (this.title === 'logistics') {
        this.$store.commit('setTab', [1, item.id])
      }
    }
  },
  mounted () {
    this.$store.commit('setTab', [0, 0])
    if (this.$route.path === '/engineering') {
      this.headRightTitle = '截止时间'
    } else {
      this.headRightTitle = '发布时间'
    }
    if (this.$route.query.logisticsTab) {
      this.tab = parseInt(this.$route.query.logisticsTab)
    }
    if (this.$route.query.engineeringTab) {
      this.tab = parseInt(this.$route.query.engineeringTab)
    }
  }
}
</script>

<style lang="scss" scoped>
.procurement {
  .tabs {
    &-item {
      font-size: 16px;
      &.active {
        span {
          position: relative;
          &::after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            bottom: -2px;
            width: 100%;
            height: 2px;
            background-color: $main-color;
          }
        }
      }
      &:not(:last-child){
        &::after {
          content: '';
          position: absolute;
          right: -0.5px;
          width: 1px;
          height: 18px;
          background-color: rgba(0, 0, 0, 0.54);
        }
      }
    }
    &-items {
      &-item {

      }
    }
  }
}
</style>
